"use client";

import Image from "next/image";
import Link from "next/link";
import { cn } from "@/lib/utils";

export function Logo({
  className,
  compact = false,
  onDark = true,
}: {
  className?: string;
  compact?: boolean;
  /** true = light wordmark for dark surfaces; false = ink wordmark for light surfaces */
  onDark?: boolean;
}) {
  const src = onDark ? "/logos/maxridge-logo-dark.png" : "/logos/maxridge-logo.png";
  const height = compact ? 30 : 42;
  const width = Math.round(height * (964 / 337));

  return (
    <Link
      href="/"
      className={cn("group inline-flex items-center", className)}
      aria-label="Maxridge home"
    >
      <Image
        src={src}
        alt="Maxridge"
        width={width}
        height={height}
        priority
        sizes="(max-width: 640px) 140px, 180px"
        className={cn(
          "h-auto w-auto max-w-[min(100%,12.5rem)] object-contain object-left",
          compact ? "max-h-8" : "max-h-10 sm:max-h-11",
        )}
      />
    </Link>
  );
}
